import { PlaybackError } from "@/lib/errors";
import styles from "@/styles/Video.module.scss";
import config from "@/lib/config";
import { Button } from "@/components/Buttons";
import { chatEnableErrorCodes } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OverlayError(_ref) {
  var _error$message;
  let {
    error,
    poster,
    isChatAvailableMeta,
    setChatDisplay
  } = _ref;
  const isPlaybackLocationError = error instanceof PlaybackError && ((error === null || error === void 0 ? void 0 : error.code) === "P-2054" || (error === null || error === void 0 ? void 0 : error.code) === "P-2055");
  const errorCode = (error === null || error === void 0 ? void 0 : error.code) || "E-500";
  const message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : "エラーが発生しました。しばらく経ってからお試しください。";
  const isChatEnableError = isChatAvailableMeta && chatEnableErrorCodes.includes(errorCode);
  if (poster) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.withPoster,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.poster,
        style: {
          backgroundImage: `url(${poster})`
        }
      }), /*#__PURE__*/_jsx("div", {
        className: styles.message,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h3", {
            className: styles.overlayError,
            children: message
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.overlayErrorCode,
            children: ["code: ", errorCode]
          }), isChatEnableError && /*#__PURE__*/_jsx(Button, {
            fillColor: true,
            medium: true,
            onClick: () => setChatDisplay(true),
            children: "\u30C1\u30E3\u30C3\u30C8\u306E\u307F\u5229\u7528\u3059\u308B"
          })]
        })
      })]
    });
  } else {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("h3", {
        className: styles.overlayError,
        children: message
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.overlayErrorCode,
        children: ["code: ", errorCode]
      }), isPlaybackLocationError && /*#__PURE__*/_jsxs("div", {
        className: styles.overlayLocationError,
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("p", {
          children: ["\u5730\u57DF\u5224\u5B9A\u30A8\u30E9\u30FC\u306B\u3064\u3044\u3066\u306E\u30D8\u30EB\u30D7\u306F\u3053\u3061\u3089", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("a", {
            href: config.staticLinks.geoRestriction,
            className: styles.linkText,
            children: config.staticLinks.geoRestriction
          })]
        })]
      }), isChatEnableError && /*#__PURE__*/_jsx(Button, {
        fillColor: true,
        medium: true,
        onClick: () => setChatDisplay(true),
        children: "\u30C1\u30E3\u30C3\u30C8\u306E\u307F\u5229\u7528\u3059\u308B"
      })]
    });
  }
}